import { fetchPOI, toProxyImageUrl } from './api'
import { savePOIContent, setBookmarkStatus, getBookmarks } from './indexeddb'

export async function pinOne(id: string, name: string, lang: string) {
  await setBookmarkStatus(id, 'pinning')
  try {
    const dLang = await fetchPOI(id, lang)
    if (dLang) await savePOIContent(id, lang, dLang)
    const dEn = lang === 'en' ? dLang : await fetchPOI(id, 'en')
    if (dEn) await savePOIContent(id, 'en', dEn)
    const t = (dLang?.summary?.thumbnail?.source) || (dEn?.summary?.thumbnail?.source)
    if (t) {
      const u = toProxyImageUrl(t)
      await fetch(u)
    }
    await setBookmarkStatus(id, 'pinned')
  } catch (e) {
    await setBookmarkStatus(id, 'failed')
  }
}

export async function unpinOne(id: string) {
  await setBookmarkStatus(id, 'not_pinned')
}

export async function pinAll(lang: string) {
  const items = await getBookmarks()
  for (const it of items) {
    await pinOne(it.id, it.name, lang)
  }
}

export async function unpinAll() {
  const items = await getBookmarks()
  for (const it of items) {
    await unpinOne(it.id)
  }
}